const INDEX_ITEMS = [
  { id: 1, title: '韩漫下拉式', desc: '韩国网漫精选合集', icon: 'ri-kakao-talk-line', count: '8500+' },
  { id: 2, title: '日漫下拉式', desc: '日本漫画热门连载', icon: 'ri-earth-line', count: '6200+' },
  { id: 3, title: '国漫专区', desc: '国产漫画精品推荐', icon: 'ri-china-railway-line', count: '3800+' },
  { id: 4, title: '恋爱甜漫', desc: '甜蜜恋爱题材精选', icon: 'ri-heart-line', count: '2100+' },
  { id: 5, title: '热血战斗', desc: '高燃战斗漫画合集', icon: 'ri-fire-line', count: '1900+' },
  { id: 6, title: '悬疑推理', desc: '烧脑悬疑漫画精选', icon: 'ri-search-eye-line', count: '1200+' },
  { id: 7, title: '奇幻冒险', desc: '异世界冒险题材大全', icon: 'ri-compass-3-line', count: '1600+' },
  { id: 8, title: '完结佳作', desc: '已完结必看漫画', icon: 'ri-check-double-line', count: '5400+' },
  { id: 9, title: '新番速递', desc: '最新上架漫画一览', icon: 'ri-rocket-line', count: '本周+48' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-3">
            漫画分类
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">下拉式漫画分类索引</h2>
          <p className="mt-2 text-foreground-600 text-sm md:text-base">按类型快速找到你想看的下拉式漫画</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4 md:gap-5">
          {INDEX_ITEMS.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              className="group flex items-start gap-4 p-4 md:p-5 rounded-2xl bg-background-50 hover:bg-background-50/80 transition-colors cursor-pointer"
            >
              <div className="w-11 h-11 rounded-xl bg-secondary-100 text-secondary-600 flex items-center justify-center flex-shrink-0 group-hover:bg-primary-100 group-hover:text-primary-600 transition-colors">
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between mb-1">
                  <h3 className="font-bold text-foreground-950 text-sm group-hover:text-primary-500 transition-colors whitespace-nowrap">
                    {item.title}
                  </h3>
                  <span className="text-xs text-primary-500 font-medium whitespace-nowrap">{item.count}</span>
                </div>
                <p className="text-xs text-foreground-600">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}